{
  "common": {
    "appName": "Aimly Admin",
    "loading": "Загрузка…",
    "retry": "Повторить",
    "cancel": "Отмена",
    "confirm": "Подтвердить",
    "prev": "Назад",
    "next": "Далее",
    "page": "{{page}} / {{total}}",
    "total": "Всего: {{count}}",
    "all": "Все",
    "yes": "Да",
    "no": "Нет",
    "back": "Назад",
    "logout": "Выйти",
    "language": "Язык",
    "theme": "Тема",
    "loadError": "Не удалось загрузить данные."
  },
  "nav": {
    "users": "Пользователи",
    "deliveries": "Доставки",
    "announcements": "Объявления",
    "sectionManage": "Управление",
    "menu": "Меню",
    "dashboard": "Дашборд"
  },
  "auth": {
    "title": "Вход в админ-панель",
    "subtitle": "Вход через Telegram. Доступ только у разрешённых администраторов.",
    "botButton": "Войти через Telegram-бота",
    "waiting": "Нажмите «Start» в боте и подтвердите вход. Страница обновится сама.",
    "openAgain": "Открыть бота снова",
    "expired": "Срок ссылки для входа истёк. Начните заново.",
    "devTitle": "Тестовый вход (только dev)",
    "devPlaceholder": "Telegram id",
    "devButton": "Войти",
    "notConfigured": "Вход через Telegram пока не настроен.",
    "checking": "Проверяем сессию…",
    "forbiddenTitle": "Нет доступа",
    "forbiddenText": "Этого Telegram-аккаунта нет в списке администраторов. Добавьте свой Telegram id в ADMIN_TELEGRAM_IDS на бэкенде.",
    "yourId": "Ваш Telegram id: {{id}}",
    "otherAccount": "Войти другим аккаунтом"
  },
  "overview": {
    "delivered": "Доставлено",
    "failed": "Ошибка",
    "pending": "В очереди",
    "successRate": "Успешно: {{percent}}%",
    "noDeliveries": "По этому каналу ещё не было отправок.",
    "failedLink": "Посмотреть ошибки"
  },
  "users": {
    "title": "Пользователи",
    "subtitle": "Поиск, состояние и блокировка",
    "name": "Пользователь",
    "tasks": "Задачи",
    "goals": "Цели",
    "telegram": "Telegram",
    "lastLogin": "Последний вход",
    "joined": "Регистрация",
    "status": "Статус",
    "active": "Активен",
    "blocked": "Заблокирован",
    "admin": "Админ",
    "reachable": "Можно писать",
    "unreachable": "Заблокировал бота",
    "emptyTitle": "Пользователи не найдены",
    "emptyText": "Сократите запрос или верните фильтр «Все».",
    "emptyNoUsers": "Пока никто не зарегистрировался. Первый пользователь появится здесь после /start в боте.",
    "open": "Открыть профиль: {{name}}",
    "language": "Язык",
    "lastActive": "Последняя активность",
    "activityActive": "Активные (7 дн.)",
    "activityInactive": "Неактивные",
    "activeToday": "сегодня",
    "daysAgo": "{{count}} дн. назад",
    "neverActive": "никогда"
  },
  "user": {
    "notFound": "Пользователь не найден.",
    "profile": "Профиль",
    "activity": "Активность",
    "schedule": "Время напоминаний",
    "language": "Язык",
    "timezone": "Часовой пояс",
    "morning": "Утренний план",
    "planning": "Планирование завтра",
    "review": "Итоги дня",
    "tasks": "Задачи",
    "completed": "Выполнено",
    "completed7d": "Выполнено (7 дней)",
    "goals": "Цели",
    "dailyReviews": "Итоги дня",
    "weeklyReviews": "Итоги недели",
    "failedDeliveries": "Ошибки Telegram",
    "telegramId": "Telegram id",
    "block": "Заблокировать",
    "unblock": "Разблокировать",
    "blockTitle": "Заблокировать пользователя?",
    "blockText": "{{name}} будет разлогинен на всех устройствах, не сможет войти и не будет получать уведомления. Данные не удаляются.",
    "unblockTitle": "Разблокировать?",
    "unblockText": "{{name}} снова сможет войти, уведомления возобновятся.",
    "blocked": "Пользователь заблокирован.",
    "unblocked": "Пользователь разблокирован.",
    "adminNote": "Аккаунт администратора нельзя заблокировать.",
    "sendMessage": "Отправить сообщение",
    "notFoundText": "Ссылка устарела или аккаунт удалён. Попробуйте найти его в списке.",
    "completed7dHint": "За неделю: {{count}}",
    "sections": "Разделы пользователя",
    "tabs": {
      "stats": "Статистика",
      "activity": "Действия",
      "profile": "Профиль"
    }
  },
  "deliveries": {
    "title": "Доставки",
    "subtitle": "Состояние уведомлений Web и Telegram",
    "status": "Статус",
    "channel": "Канал",
    "type": "Тип",
    "recipient": "Кому",
    "attempts": "Попытки",
    "created": "Создано",
    "sentAt": "Отправлено",
    "error": "Ошибка",
    "retry": "Отправить снова",
    "retried": "Отправлено повторно: {{status}}",
    "emptyTitle": "Доставок не найдено",
    "emptyText": "По выбранному фильтру записей нет. Верните фильтр «Все».",
    "statuses": {
      "PENDING": "В очереди",
      "SENT": "Отправлено",
      "FAILED": "Ошибка",
      "READ": "Прочитано",
      "SKIPPED": "Пропущено"
    },
    "channels": {
      "WEB": "Web",
      "TELEGRAM": "Telegram"
    },
    "types": {
      "DAILY_PLAN": "План на день",
      "PLANNING_REMINDER": "Напоминание о планировании",
      "TASK_REMINDER": "Напоминание о задаче",
      "TASK_OVERDUE": "Просроченная задача",
      "TASK_POSTPONED": "Перенесённая задача",
      "DAILY_REVIEW": "Итоги дня",
      "WEEKLY_REVIEW": "Итоги недели",
      "SYSTEM": "Объявление"
    }
  },
  "announcements": {
    "title": "Объявления",
    "subtitle": "Сообщение пользователям через Web и Telegram",
    "new": "Новое объявление",
    "formTitle": "Заголовок",
    "formBody": "Текст",
    "target": "Кому",
    "targetAll": "Всем активным пользователям",
    "targetOne": "Одному пользователю",
    "targetId": "Telegram id",
    "send": "Отправить",
    "confirmTitle": "Отправить объявление?",
    "confirmAll": "Сообщение уйдёт всем активным пользователям. Отменить нельзя.",
    "confirmOne": "Сообщение получит владелец Telegram id {{id}}.",
    "sent": "Объявление отправлено {{count}} получателям.",
    "history": "Отправленные",
    "toAll": "Всем",
    "toOne": "Одному пользователю",
    "emptyTitle": "Объявлений ещё не было",
    "emptyText": "Чтобы сообщить о новой функции или техработах, используйте форму слева.",
    "hint": "В Telegram объявление приходит как «📣 заголовок»; тем, кто отключил уведомления, оно видно только в Web.",
    "validation": {
      "title": "Заголовок — от 1 до 200 символов.",
      "body": "Текст — от 1 до 2000 символов.",
      "telegramId": "Telegram id состоит только из цифр."
    },
    "preview": "Так это увидят в Telegram",
    "recipientsColumn": "Получатели",
    "sentAt": "Отправлено"
  },
  "notFound": {
    "title": "Страница не найдена",
    "action": "На главную",
    "text": "Адрес неверен или страница перемещена. Выберите раздел в меню."
  },
  "errors": {
    "UNKNOWN_ERROR": "Что-то пошло не так. Попробуйте ещё раз.",
    "NETWORK_ERROR": "Нет связи с сервером. Проверьте интернет.",
    "INTERNAL_ERROR": "Ошибка сервера. Попробуйте немного позже.",
    "VALIDATION_FAILED": "Данные заполнены неверно.",
    "NOT_FOUND": "Не найдено.",
    "FORBIDDEN": "Нет доступа.",
    "RATE_LIMITED": "Слишком много попыток. Повторите через минуту.",
    "NO_TOKEN": "Требуется вход.",
    "TOKEN_EXPIRED": "Сессия истекла.",
    "TOKEN_INVALID": "Сессия недействительна. Войдите снова.",
    "TOKEN_STALE": "Сессия закрыта. Войдите снова.",
    "AUTH_FAILED": "Не удалось войти. Попробуйте ещё раз.",
    "ACCOUNT_BLOCKED": "Аккаунт заблокирован.",
    "REFRESH_TOKEN_INVALID": "Сессия завершена. Войдите снова.",
    "REFRESH_TOKEN_REUSED": "Сессия закрыта в целях безопасности. Войдите снова.",
    "TELEGRAM_NOT_CONFIGURED": "Вход через Telegram пока не настроен.",
    "LOGIN_REQUEST_NOT_FOUND": "Запрос на вход не найден или уже использован. Начните заново.",
    "LOGIN_REQUEST_EXPIRED": "Срок ссылки для входа истёк. Начните заново.",
    "DEV_LOGIN_DISABLED": "Тестовый вход отключён.",
    "USER_NOT_FOUND": "Пользователь не найден.",
    "ADMIN_ONLY": "Раздел только для администраторов.",
    "CANNOT_BLOCK_ADMIN": "Аккаунт администратора нельзя заблокировать.",
    "DELIVERY_NOT_FOUND": "Доставка не найдена.",
    "DELIVERY_NOT_RETRYABLE": "Повторно можно отправить только доставку с ошибкой."
  },
  "table": {
    "search": "Поиск…",
    "clear": "Очистить",
    "clearAll": "Сбросить все",
    "filterBy": "Фильтр: {{column}}",
    "removeFilter": "Убрать фильтр: {{column}}",
    "sortBy": "Сортировать: {{column}}",
    "sortedAsc": "{{column}}: по возрастанию",
    "sortedDesc": "{{column}}: по убыванию",
    "columns": "Столбцы",
    "columnsHint": "Видимые столбцы",
    "showAll": "Показать все",
    "hiddenCount": "Скрыто столбцов: {{count}}",
    "rowsPerPage": "На странице",
    "range": "{{from}}–{{to}}",
    "of": "из {{total}}",
    "pages": "Страницы",
    "goToPage": "Страница {{page}}"
  },
  "dashboard": {
    "title": "Дашборд",
    "subtitle": "Как работает Aimly — с первого взгляда.",
    "greeting": "С возвращением, {{name}}! Все показатели за выбранный период — здесь.",
    "presets": {
      "today": "Сегодня",
      "7d": "7 дней",
      "30d": "30 дней",
      "90d": "90 дней",
      "year": "Год"
    },
    "filters": {
      "period": "Период",
      "from": "Дата начала",
      "to": "Дата окончания",
      "language": "Язык пользователей",
      "allLanguages": "Все языки",
      "channel": "Канал",
      "allChannels": "Все каналы",
      "activeWindow": "Окно активности",
      "activeDays": "Актив: {{count}} дн.",
      "reset": "Сбросить фильтры"
    },
    "deltaNew": "новое",
    "deltaPoints": "{{value}} п.",
    "deltaHint": "За предыдущий период: {{value}}",
    "hoursMinutes": "{{hours}} ч {{minutes}} мин",
    "weekdays": "Пн,Вт,Ср,Чт,Пт,Сб,Вс",
    "activity": {
      "title": "Активность пользователей",
      "subtitle": "Активен — входил или что-то делал за последние {{count}} дн.",
      "active": "Активные",
      "inactive": "Неактивные",
      "activeShare": "активны",
      "dau": "DAU",
      "wau": "WAU",
      "mau": "MAU",
      "stickiness": "Липкость",
      "stickinessHint": "DAU / MAU: как часто люди возвращаются"
    },
    "users": {
      "total": "Всего пользователей",
      "new": "Новые",
      "atRisk": "Под риском ухода",
      "atRiskHint": "Были активны в прошлые {{count}} дн., сейчас нет",
      "never": "Не активировались",
      "neverHint": "Не создали ни одной задачи",
      "reachable": "Бот может писать",
      "blocked": "Заблокированы"
    },
    "series": {
      "title": "Динамика",
      "activeUsers": "Активные",
      "signups": "Регистрации",
      "tasksCreated": "Созданные задачи",
      "tasksCompleted": "Выполненные задачи",
      "inPeriod": "за период",
      "bucket": {
        "day": "По дням",
        "week": "По неделям",
        "month": "По месяцам"
      }
    },
    "tasks": {
      "created": "Создано",
      "completed": "Выполнено",
      "rate": "Выполнение",
      "rateHint": "В плане: {{count}}",
      "postponed": "Перенесено",
      "cancelled": "Отменено",
      "focus": "Время фокуса",
      "focusHint": "Фактическое время выполненных"
    },
    "clock": {
      "title": "Когда работают",
      "hours": "Выполнение по часам",
      "weekdays": "По дням недели",
      "peak": "Пиковый час — {{hour}}:00",
      "empty": "За период нет выполненных задач."
    },
    "funnel": {
      "title": "Воронка активации",
      "subtitle": "До какого шага дошли зарегистрированные",
      "registered": "Зарегистрировались",
      "createdTask": "Создали задачу",
      "completedTask": "Выполнили задачу",
      "wroteReview": "Написали обзор",
      "empty": "За период нет новых пользователей — расширьте период."
    },
    "top": {
      "title": "Самые активные",
      "subtitle": "Выполнено / в плане",
      "empty": "За период никто не выполнил задач."
    },
    "goals": {
      "title": "Цели и обзоры",
      "created": "Новые цели",
      "completed": "Достигнуто",
      "active": "Активные цели"
    },
    "reviews": {
      "daily": "Дневные обзоры",
      "weekly": "Недельные обзоры",
      "period": "Месяц/год"
    },
    "languages": {
      "title": "Языки",
      "subtitle": "Все пользователи"
    },
    "deliveries": "Доставка уведомлений",
    "hoursOnly": "{{hours}} ч"
  },
  "userStats": {
    "period": "Период",
    "periods": {
      "day": "День",
      "week": "Неделя",
      "month": "Месяц",
      "year": "Год"
    },
    "prev": "Предыдущий период",
    "next": "Следующий период",
    "today": "Сегодня",
    "planned": "В плане",
    "completed": "Выполнено",
    "rate": "Выполнение",
    "focus": "Время фокуса",
    "postponed": "Перенесено",
    "cancelled": "Отменено",
    "activeDays": "Активные дни",
    "logins": "Входы",
    "chart": "План и выполнение",
    "chartHours": "По часам",
    "legend": "Светлый столбец — план, тёмный — выполнено",
    "legendHours": "Светлый — создано, тёмный — выполнено",
    "priority": "По приоритету",
    "priorities": {
      "HIGH": "Высокий",
      "MEDIUM": "Средний",
      "LOW": "Низкий"
    },
    "goalsCreated": "Цели",
    "goalsCompleted": "Достигнуто",
    "reviews": "Обзоры",
    "calendar": "Календарь активности",
    "calendarHint": "Последний год; нажмите на день, чтобы открыть его статистику",
    "calendarSummary": "{{days}} активных дней, {{total}} действий",
    "calendarCell": "{{date}}: действий {{count}}",
    "less": "Меньше",
    "more": "Больше"
  },
  "activity": {
    "at": "Время",
    "event": "Действие",
    "object": "Объект",
    "detail": "Детали",
    "forDate": "дата: {{date}}",
    "unknownDevice": "Неизвестное устройство",
    "emptyTitle": "Действий нет",
    "emptyText": "Пользователь ещё ничего не сделал: первый вход или задача появятся здесь.",
    "emptyFiltered": "Нет действий этого типа — снимите фильтр.",
    "groups": {
      "session": "Входы",
      "task": "Задачи",
      "goal": "Цели",
      "review": "Обзоры",
      "notification": "Уведомления"
    },
    "types": {
      "LOGIN": "Вход",
      "TASK_CREATED": "Создал задачу",
      "TASK_COMPLETED": "Выполнил задачу",
      "TASK_POSTPONED": "Перенёс задачу",
      "TASK_CANCELLED": "Отменил задачу",
      "GOAL_CREATED": "Поставил цель",
      "GOAL_COMPLETED": "Достиг цели",
      "GOAL_ARCHIVED": "Архивировал цель",
      "DAILY_REVIEW": "Написал дневной обзор",
      "WEEKLY_REVIEW": "Написал недельный обзор",
      "PERIOD_REVIEW": "Написал обзор периода",
      "NOTIFICATION_READ": "Прочитал уведомление"
    },
    "goalTypes": {
      "YEAR": "годовая цель",
      "QUARTER": "квартальная цель",
      "MONTH": "месячная цель",
      "WEEK": "недельная цель"
    },
    "periods": {
      "MONTH": "Месячный обзор",
      "YEAR": "Годовой обзор"
    }
  }
}
